module.exports = __webpack_public_path__ + "img/iso14001-en.54637c24.png";